import Vue from "vue";
import Router from "vue-router";
import Home from "@/view/index";
import Home1 from "@/view/index1";
import Home2 from "@/view/index2";
import HomeDwq from "@/view/indexdwq";
import Ref from "@/view/ref";
import privacy from "@/view/privacy";
import agreement from "@/view/agreement";

Vue.use(Router);

export default new Router({
  routes: [
    { path: "/", name: "Home", component: Home },
    { path: "/index", name: "Home", component: Home },
    { path: "/index1", name: "Home", component: Home1 },
    { path: "/index2", name: "Home", component: Home2 },
    { path: "/ref", name: "Ref", component: Ref },
    { path: "/privacy", component: privacy, name: "privacy" },
    { path: "/agreement", component: agreement, name: "agreement" },
    { path: "/indexdwq", component: HomeDwq, name: "HomeDwq" }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js